import { Download } from 'lucide-react'
import { Button, Card, Col, Form, Row } from 'react-bootstrap'

const FormControlStyle = {
  height: '45px',
  borderRadius: '10px',
  border: '1px solid #e9ecef',
  backgroundColor: '#ffffff',
  fontSize: '0.9rem'
}

const ActionButtons = ({
  type,
  selectedProblem,
  setSelectedProblem,
  selectedID,
  selectedWarehouse,
  typeWarehouse,
  handleRedirectPageCreateTicket,
  handleExportReject,
  handleActionMutation,
  downloadingExport,
  stocks
}) => {
  if (type !== 'quarantine' && type !== 'rejected') return null

  return (
    <Card className="mb-3 border-0 bg-light rounded-3 p-3">
      <Row className="align-items-center">
        <Col md={3}>
          <Form.Select
            value={selectedProblem || ''}
            onChange={(e) => setSelectedProblem(e.target.value)}
            style={{ ...FormControlStyle, fontSize: '0.85rem' }}
            placeholder="Select Problem"
          >
            <option value="">Select Problem Filter</option>
            <option value="bocor">Bocor</option>
            <option value="tidak_ada_label">Tidak Ada Label</option>
            <option value="tidak_ada_segel">Tidak Ada Segel</option>
            <option value="coa_not_match">Coa Not Match</option>
          </Form.Select>
        </Col>
        <Col
          md={9}
          className="text-end d-flex gap-2 justify-content-end align-items-center"
        >
          {type === 'quarantine' && (
            <>
              <Button
                variant={
                  selectedID.length && selectedWarehouse
                    ? 'warning'
                    : 'secondary'
                }
                className={`rounded px-4 ${
                  selectedID.length && selectedWarehouse
                    ? 'text-white'
                    : 'opacity-50'
                }`}
                onClick={() => handleActionMutation('restock')}
                disabled={!selectedID.length || !selectedWarehouse}
                style={{ fontWeight: '600' }}
              >
                Send Back
              </Button>
              <Button
                variant={
                  selectedID.length && selectedWarehouse
                    ? 'danger'
                    : 'secondary'
                }
                className={`rounded px-4 ${
                  selectedID.length && selectedWarehouse ? '' : 'opacity-50'
                }`}
                onClick={() => handleActionMutation('reject')}
                disabled={!selectedID.length || !selectedWarehouse}
                style={{ fontWeight: '600' }}
              >
                Reject Item
              </Button>
            </>
          )}
          {type === 'rejected' && (
            <>
              <Button
                variant="outline-warning"
                className="fw-bold d-flex align-items-center justify-content-center gap-2"
                onClick={handleExportReject}
                disabled={downloadingExport || !stocks?.length}
                style={{ borderRadius: '8px' }}
              >
                <Download size={16} />
                {downloadingExport ? 'Exporting...' : 'Export'}
              </Button>
              <Button
                variant={
                  selectedID.length && selectedWarehouse
                    ? 'danger'
                    : 'secondary'
                }
                className={`rounded px-4 ${
                  selectedID.length && selectedWarehouse ? '' : 'opacity-50'
                }`}
                disabled={!selectedID.length || !selectedWarehouse}
                onClick={() => handleActionMutation('karantina')}
                style={{ fontWeight: '600' }}
              >
                Send to Quarantine
              </Button>
              <Button
                variant={
                  selectedID.length && selectedWarehouse
                    ? 'warning'
                    : 'secondary'
                }
                className={`rounded px-4 ${
                  selectedID.length && selectedWarehouse
                    ? 'text-white'
                    : 'opacity-50'
                }`}
                disabled={!selectedID.length || !selectedWarehouse}
                onClick={() => handleRedirectPageCreateTicket('disposal')}
                style={{ fontWeight: '600' }}
              >
                Disposal
              </Button>
              <Button
                variant={
                  selectedID.length &&
                  typeWarehouse !== 'external' &&
                  selectedWarehouse
                    ? 'danger'
                    : 'secondary'
                }
                className={`rounded px-4 ${
                  selectedID.length &&
                  typeWarehouse !== 'external' &&
                  selectedWarehouse
                    ? ''
                    : 'opacity-50'
                }`}
                disabled={
                  !selectedID.length ||
                  !selectedWarehouse ||
                  typeWarehouse === 'external'
                }
                onClick={() => handleRedirectPageCreateTicket('material_issue')}
                style={{ fontWeight: '600' }}
              >
                Material Issue
              </Button>
            </>
          )}
        </Col>
      </Row>
    </Card>
  )
}

export default ActionButtons
